import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Fragment, useEffect } from 'react';
import { setAccessToken } from '@partiu/api/axios.ts';

function safeNext(value: string | null): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null;
  return value;
}

export function AutoLoginPage({ redirectTo = '/' }: { redirectTo?: string }) {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const next = safeNext(searchParams.get('next'));
  const year = searchParams.get('year');
  const month = searchParams.get('month');
  const volumetry =
    year && month && /^\d{4}$/.test(year) && /^(?:[1-9]|1[0-2])$/.test(month)
      ? `/financeiro/volumetria?year=${year}&month=${month}`
      : null;

  useEffect(() => {
    if (!token) return;

    localStorage.removeItem('agreementId');

    setAccessToken(token);
    navigate(volumetry || next || redirectTo);
  }, [token, volumetry, next, navigate, redirectTo]);

  return <Fragment />;
}
